export default [
  {
    name: 'Manager.Clients',
    path: 'clients',
    component: () => import('./components/clients/List')
  },
  {
    name: 'Manager.Clients.Show',
    path: 'clients/show/:id',
    props: true,
    component: () => import('./components/clients/Show')
  }
]
